import { connect } from "react-redux";

import {
    isLoggedIn,
    getCustomerEmail,
    getCustomerFirstName,
    getCustomerLastName,
} from "shared/store/app/selectors";

import { fetchUser } from "shared/store/app/services";

import {
    getUserI18N,
    getCurrenciesRaw,
    getCountries,
    getXHRStatus,
    onGDPRNetwork,
} from "shared/store/internationalization/selectors";
import { updateCountry, updateCurrency } from "shared/store/internationalization/actions";
import { setWebAppType } from "shared/store/app/actions";
import { fetchOffer } from "shared/store/app/services";
import { setData as setDefaultCookies } from "shared/store/internationalization/services";
import { getRemoteConfig } from "shared/store/remoteConfigs/selectors";

import Boot from "./Boot";

const mapStateToProps = (state: any) => ({
    userEmail: getCustomerEmail(state),
    firstName: getCustomerFirstName(state),
    lastName: getCustomerLastName(state),
    isLoggedInUser: isLoggedIn(state),
    countries: getCountries(state),
    currencies: getCurrenciesRaw(state),
    isI18nLoading: state.internationalization.isLoading,
    selectedCurrency: getUserI18N(state).currency,
    selectedCountryCode: getUserI18N(state).countryCode,
    selectedCountryName: getUserI18N(state).country,
    currencyDisplayValue: getUserI18N(state).currencyDisplayValue,
    isXHRAllowed: getXHRStatus(state),
    onGDPRNetwork: onGDPRNetwork(state),
    dnsLinks: getRemoteConfig(state, "dns_links"),
});

const mapDispatchToProps = {
    fetchUser,
    updateCountry,
    updateCurrency,
    fetchOffer,
    setDefaultCookies,
    setWebAppType,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Boot);
